import garantiesService from "./garantiesService";
import prestationService from "./prestationService";
import * as GARANTIES from "@/classes/parametrage/garanties";
import * as OPTIONS from "@/classes/parametrage/options";

export default {
  getMaladie(userInput, idOption = OPTIONS.OBLIGATION_STATUTAIRE) {
    var result = {
      montant: 0,
      pourcentageCouverture: 0,
      ordinaire: this.getCongeMaladie(userInput, idOption, GARANTIES.MALADIE_ORDINAIRE),
      longueMaladieGraveMaladie: this.getCongeMaladie(userInput, idOption, GARANTIES.MALADIE_LONGUE_MALADIE_GRAVE),
      longueDuree: this.getCongeMaladie(userInput, idOption, GARANTIES.MALADIE_LONGUE_DUREE),
    };

    result.montant = result.ordinaire.montant + result.longueMaladieGraveMaladie.montant + result.longueDuree.montant;

    return result;
  },

  getOption(userInput, idOption, idGarantie, idCritere) {
    var plafondNet = prestationService.getPlafondNet(userInput);

    var tauxOption = garantiesService.getParametragesGaranties(GARANTIES.TYPE_MALADIE, idGarantie, idOption, idCritere);
    var tauxSalaire = tauxOption.find((x) => x.idTypeRemuneration == GARANTIES.TIB_NBI).tauxOption;
    var tauxPrimes = tauxOption.find((x) => x.idTypeRemuneration == GARANTIES.PRIMES_INDEMNITES).tauxOption;

    // Part salaire : (salaire brut - primes) * taux paramétré pour cette garantie/option/profil (contractuel/fonctionnaire)
    // La part salaire ne peut pas excéder le plafond net du salaire
    var partSalaire = (userInput.salaireBrut - userInput.primes) * tauxSalaire;

    // TODO : décommenter pour "limiter au net"
    // if (partSalaire > plafondNet.salaire) {
    //   partSalaire = plafondNet.salaire;
    // }

    // Part primes : primes * taux paramétré pour cette garantie/option/profil (contractuel/fonctionnaire)
    // La part primes ne peut pas excéder le plafond net des primes
    var partPrimes = userInput.primes * tauxPrimes;

    // TODO : décommenter pour "limiter au net"
    // if (partPrimes > plafondNet.primes) {
    //   partSalaire = plafondNet.salaire;
    // }

    // Montant affiché : total des deux parts
    // Le montant ne peut pas excéder la somme du plafond total du salaire et du plafond total des primes (partie faite en aval)
    var montant = partSalaire + partPrimes;

    return {
      totalNet: montant,
      resteACharge: plafondNet.total - montant,
    };
  },

  getCongeMaladie(userInput, idOption = OPTIONS.OBLIGATION_STATUTAIRE, idGarantie) {
    var result = undefined;
    // var coeffBrutNet = prestationService.getCoeffsBrutNet(userInput.isContractuel); // TODO : décommenter pour "limiter au net"
    var plafondNet = prestationService.getPlafondNet(userInput);
    // var salaireNet = (userInput.salaireBrut - userInput.primes) * coeffBrutNet.traitementDeBase; // TODO : décommenter pour "limiter au net"
    // var primesNet = userInput.primes * coeffBrutNet.primes; // TODO : décommenter pour "limiter au net"
    // var totalNet = salaireNet + primesNet; // TODO : décommenter pour "limiter au net"

    var remunerationOption = {
      pleinTraitement: this.getOption(userInput, idOption, idGarantie, GARANTIES.PLEIN_TRAITEMENT),
      demiTraitement: this.getOption(userInput, idOption, idGarantie, GARANTIES.DEMI_TRAITEMENT),
    };

    // TODO : décommenter pour "limiter au net"
    // Le total net ne peut pas excéder le salaire net de l'agent
    // if (remunerationOption.pleinTraitement.totalNet > totalNet) {
    //   remunerationOption.pleinTraitement.totalNet = totalNet;
    // }
    // if (remunerationOption.demiTraitement.totalNet > totalNet) {
    //   remunerationOption.demiTraitement.totalNet = totalNet;
    // }

    result = {
      montant: Math.floor(remunerationOption.pleinTraitement.totalNet + remunerationOption.demiTraitement.totalNet),
      pleinTraitement: Math.floor(remunerationOption.pleinTraitement.totalNet),
      resteAChargePleinTraitement: Math.floor(plafondNet.total - remunerationOption.pleinTraitement.totalNet),
      demiTraitement: Math.floor(remunerationOption.demiTraitement.totalNet),
      resteAChargeDemiTraitement: Math.floor(plafondNet.total - remunerationOption.demiTraitement.totalNet),
    };

    return result;
  },
};
